/**
 * Carrier agent portals ("quick links") — where an agent signs in to write
 * business once a contract is active.
 *
 * Keyed by {@link Carrier} so a typo cannot invent a carrier. A carrier with
 * no entry simply has no quick link yet; callers must handle `null`.
 */
import { Carrier, CARRIER_SLUG_TO_CARRIER } from "./carriers.js";
export const CARRIER_PORTAL_URLS = {
    [Carrier.AFLAC]: "http://www.sellaflacseniorplans.com/",
    [Carrier.AMERICAN_AMICABLE]: "https://www.americanamicable.com/v4/agentLogin.php",
    [Carrier.AMERICAN_HOME_LIFE]: "https://www.aetnaseniorproducts.com/ssibrokerwebaz/agent/management/dashboard?channel=amh",
    [Carrier.BALTIMORE_LIFE]: "https://agentportal.baltlife.com/",
    [Carrier.COREBRIDGE]: "https://www.connext.corebridgefinancial.com/life/connext-portal/public/login",
    [Carrier.F_AND_G]: "https://saleslink.fglife.com/",
    [Carrier.GERBER]: "https://www.gerberlifeagency.com/",
    [Carrier.ILLINOIS_MUTUAL]: "https://identity.illinoismutual.com/identity/login",
    [Carrier.INSTABRAIN]: "https://portal.instabrain.io/Account/Login",
    [Carrier.MUTUAL_OF_OMAHA]: "https://login.mutualofomaha.com/",
    [Carrier.ROYAL_NEIGHBORS]: "https://agent.royalneighbors.org/login",
    [Carrier.TRANSAMERICA]: "https://secure.transamerica.com/",
};
/**
 * Portal URL for a carrier, accepting either the {@link Carrier} enum value
 * (`"TRANSAMERICA"`) or the form/contract slug (`"transamerica"`).
 * Returns null when we have no portal on file for that carrier.
 */
export function carrierPortalUrl(carrier) {
    if (!carrier)
        return null;
    const resolved = CARRIER_SLUG_TO_CARRIER[carrier.trim().toLowerCase()] ?? null;
    return resolved ? CARRIER_PORTAL_URLS[resolved] ?? null : null;
}
